import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { PhotoQuality } from '../lib/image';

export type Theme = 'day' | 'night';
export type TextScale = 'normal' | 'large';

interface SettingsState {
  theme: Theme;
  textScale: TextScale;
  photoQuality: PhotoQuality;
  /** Изключено: снимките чакат Wi-Fi, събитията тръгват винаги. */
  uploadPhotosOnMobileData: boolean;
  /**
   * Позиция във фонов режим. По подразбиране ИЗКЛЮЧЕНО и това е съзнателно:
   * бусът има собствено бордово устройство и то е източникът на позицията.
   * Телефонът дава точка само в петте момента на курса.
   */
  backgroundPosition: boolean;
  keepScreenAwake: boolean;
  setTheme: (theme: Theme) => void;
  setTextScale: (scale: TextScale) => void;
  setPhotoQuality: (quality: PhotoQuality) => void;
  setUploadPhotosOnMobileData: (value: boolean) => void;
  setBackgroundPosition: (value: boolean) => void;
  setKeepScreenAwake: (value: boolean) => void;
}

export const useSettings = create<SettingsState>()(
  persist(
    (set) => ({
      theme: 'day',
      textScale: 'normal',
      photoQuality: 'normal',
      uploadPhotosOnMobileData: true,
      backgroundPosition: false,
      keepScreenAwake: true,
      setTheme: (theme) => set({ theme }),
      setTextScale: (textScale) => set({ textScale }),
      setPhotoQuality: (photoQuality) => set({ photoQuality }),
      setUploadPhotosOnMobileData: (uploadPhotosOnMobileData) => set({ uploadPhotosOnMobileData }),
      setBackgroundPosition: (backgroundPosition) => set({ backgroundPosition }),
      setKeepScreenAwake: (keepScreenAwake) => set({ keepScreenAwake }),
    }),
    { name: 'kmdx.driver.settings' },
  ),
);

/** Темата се прилага върху <html>, за да важи и за фона зад приложението. */
export function applyAppearance(theme: Theme, textScale: TextScale): void {
  const root = document.documentElement;
  root.dataset.theme = theme;
  root.dataset.text = textScale;
  const meta = document.querySelector('meta[name="theme-color"]');
  meta?.setAttribute('content', theme === 'night' ? '#05080f' : '#0b1220');
}
